<template>
  <div class="campaign-status">
    <div v-if="statusLabel" :class="statusLabel.textClass">
      <template v-for="(line, index) in statusLabel.lines">
        <br v-if="index > 0" :key="index" />
        {{ line }}
      </template>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

import { resolveCampaignStatusLabel } from './campaignStatusLabel'

export default defineComponent({
  props: {
    status: {
      type: Number,
      default: null
    },
    // 種別（トップレベルの entryActionType）。リポスト/引用系のみ応募者数で分岐する。
    entryActionType: {
      type: String,
      default: null
    },
    // 応募者数
    applicantsCount: {
      type: Number,
      default: 0
    }
  },
  computed: {
    statusLabel() {
      return resolveCampaignStatusLabel({
        status: this.status,
        entryActionType: this.entryActionType,
        applicantsCount: this.applicantsCount
      })
    }
  }
})
</script>
